import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://autoria.dev';
const SITE_NAME = 'Autoria';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

const SEO = ({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  imageAlt,
  type = 'website',
  article = null,
  noindex = false,
  breadcrumb = null,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Outils sur mesure pour l'e-commerce`;
  const url = `${SITE_URL}${path}`;
  const altText = imageAlt || fullTitle;
  // Fil d'Ariane pour Google (Accueil › … › page) : affiché dans les résultats à la place de l'adresse.
  const crumbs = breadcrumb && {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [['Accueil', '/'], ...breadcrumb].map(([name, p], i) => ({ '@type': 'ListItem', position: i + 1, name, item: `${SITE_URL}${p}` }))
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="fr-FR" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {crumbs && <script type="application/ld+json">{JSON.stringify(crumbs)}</script>}

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={altText} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_FR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={altText} />

      {article && (
        <>
          <meta property="article:published_time" content={article.publishedTime} />
          <meta property="article:author" content={SITE_NAME} />
          {article.tags?.map((tag, i) => (
            <meta key={i} property="article:tag" content={tag} />
          ))}
        </>
      )}
    </Helmet>
  );
};

export default SEO;
